<template>
    <u-btn-custom v-bind="$attrs" color="primary" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-custom>
</template>

<script>
import UBtnCustom from "@/components/publish/styles/buttons/u-btn-custom.vue";

export default {
    props: {},
    components: {
        UBtnCustom,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
